"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSGameTron = void 0;
const KHRandom_1 = require("./KH/KHRandom");
const TSBlock_1 = require("./TSBlock");
const TSColors_1 = require("./TSColors");
class TSGameTron {
    constructor(playerStartPoints, maxLen = Infinity) {
        this.moveNum = 0;
        this._startPoints = playerStartPoints;
        this._maxLen = maxLen;
    }
    onStart(scene) {
        this.paths = [];
        const colorArr = [TSColors_1.TSBlockType.Blue, TSColors_1.TSBlockType.Red, TSColors_1.TSBlockType.Green, TSColors_1.TSBlockType.Yellow];
        for (let i = 0; i < this._startPoints.length; i++) {
            const point = this._startPoints[i];
            const block = new TSBlock_1.TSBlock(scene, colorArr[i], TSBlock_1.TSBlockAttribute.LoseOnTouch);
            this.gameInterface.addBlock(block, point[0], point[1], i == 0);
            this.paths.push([block]);
        }
        this._scene = scene;
    }
    onWillMove(block) {
        // Intentionally skipping 0, the player's path.
        for (let i = 1; i < this.paths.length; i++) {
            const playerPath = this.paths[i];
            const others = this.paths.filter(x => x != playerPath).map(x => x[0]);
            const head = playerPath[0];
            const rand = new KHRandom_1.KHRandomGeneral();
            const next = rand.getRandom(this.safeDirOrPossible(head, others));
            this.doNPCMove(playerPath, next);
        }
    }
    computeNPCMove(path, otherPlayerPos, grid) {
    }
    safeDirOrPossible(block, otherPlayers) {
        const safe = this.safeDirs(block);
        if (safe.length == 0)
            return this.possibleDirs(block);
        if (safe.length > 0) {
            const superSafe = safe.filter(x => {
                const pos = TSBlock_1.TSBlockMoving.ModifiedLocForBlock(block, x);
                for (let other of otherPlayers) {
                    // If 1 away in 1 direction, discard that possibility
                    if ((Math.abs(pos[0] - other.pos.x) == 1) != (Math.abs(pos[1] - other.pos.y) == 1)) {
                        return false;
                    }
                    return true;
                }
            });
            if (superSafe.length > 0)
                return superSafe;
        }
        return safe;
    }
    safeDirs(block) {
        return this.possibleDirs(block).filter(x => {
            const newPos = TSBlock_1.TSBlockMoving.ModifiedLocForBlock(block, x);
            return this.gameInterface.grid.at(...newPos).length == 0;
        });
    }
    possibleDirs(block) {
        const dirs = [];
        if (block.pos.x != 0)
            dirs.push(TSBlock_1.TSDir.Left);
        if (block.pos.x != 5)
            dirs.push(TSBlock_1.TSDir.Right);
        if (block.pos.y != 0)
            dirs.push(TSBlock_1.TSDir.Up);
        if (block.pos.y != 5)
            dirs.push(TSBlock_1.TSDir.Down);
        return dirs;
    }
    doNPCMove(path, dir) {
        const start = path[0];
        const newStart = new TSBlock_1.TSBlock(this._scene, start.getType(), path[0].attr);
        path.unshift(newStart);
        const pos = TSBlock_1.TSBlockMoving.ModifiedLocForBlock(start, dir);
        this.gameInterface.addBlockNoAnim(newStart, ...pos);
    }
    updatePlayerPath(oldFront, path) {
        for (let i = 1; i < path.length; i++) {
            const pos = path[i].pos;
            this.gameInterface.grid.forceMoveTo(path[i], ...oldFront);
            oldFront = [pos.x, pos.y];
        }
        if (path.length < this._maxLen && path.length > 0) {
            const block = new TSBlock_1.TSBlock(this._scene, path[0].getType(), path[0].attr);
            this.gameInterface.addBlockNoAnim(block, oldFront[0], oldFront[1]);
            path.push(block);
        }
    }
    killPath(path) {
        for (let block of path) {
            block.kill();
        }
    }
    onDidMove(block, previousPos, desiredPos, successfullyMoved) {
        const lastDir = TSBlock_1.TSBlockMoving.DirForOffset([desiredPos[0] - previousPos[0], desiredPos[1] - previousPos[1]]);
        const others = this.gameInterface.blocksAt(block.pos.x, block.pos.y);
        let lost = false;
        for (let i = 0; i < others.length; i++) {
            if (others[i] == block)
                continue;
            if (others[i].attr == TSBlock_1.TSBlockAttribute.LoseOnTouch) {
                lost = true;
                break;
            }
        }
        // Check player lose
        if (!successfullyMoved || lost) {
            this.killPath(this.paths[0]);
            this.gameInterface.lose();
            return;
        }
        this.updatePlayerPath(previousPos, this.paths[0]);
        const idxsToKill = [];
        // Check NPC lose
        for (let i = 1; i < this.paths.length; i++) {
            const head = this.paths[i][0];
            if (this.gameInterface.grid.at(head.pos.x, head.pos.y).length > 1) {
                idxsToKill.push(i);
            }
        }
        for (let i = idxsToKill.length - 1; i >= 0; i--) {
            const idx = idxsToKill[i];
            this.killPath(this.paths[idx]);
            this.paths.splice(idx, 1);
        }
        if (this.paths.length == 1) {
            this.gameInterface.win();
        }
    }
    static TwoPlayer() {
        return new TSGameTron([[1, 4], [4, 1]]);
    }
    static ThreePlayer() {
        return new TSGameTron([[4, 2], [1, 0], [1, 4]]);
    }
    static FourPlayer() {
        return new TSGameTron([[1, 4], [4, 1], [1, 1], [4, 4]]);
    }
}
exports.TSGameTron = TSGameTron;
